<template>
    <div class="demo-row-item">
        <link-button type="none" class="demo-row-item-title" :style="titleStyles" v-if="!!title">{{title}}</link-button>
        <div class="demo-row-item-content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "demo-row-item",
        props: {
            title: {},
            titleWidth: {default: '200px'},
        },
        computed: {
            titleStyles() {
                return {
                    width: this.titleWidth
                }
            },
        }
    }
</script>

<style lang="scss">
    .demo-row-item {
        display: flex;
        height: 44px;
        margin-bottom: 12px;
        align-items: center;
    }
</style>
